import { memo, type ComponentType } from 'react';
import { componentWithCondition } from '../component-with-condition/index.tsx';

/**
 * A utility function that conditionally applies React.memo on a component based on a provided condition.
 * Useful for if you want to memoize a component that uses a relay fragment, so that you don't need
 * to rename the component and cause relay/linting to change the fragment names.
 */
export const memoWithCondition = <P extends {}>(
	condition: () => boolean,
	Component: ComponentType<P>,
	propsAreEqual?: (prevProps: Readonly<P>, nextProps: Readonly<P>) => boolean,
) => {
	return componentWithCondition(condition, memo(Component, propsAreEqual), Component);
};
